const useSharetribeImage = (image, selectedVariants = []) => {
  if (!image.id) {
    throw new Error('Image is missing id');
  }

  if (selectedVariants.length === 0) {
    throw new Error('No variants selected');
  }

  const variantExisting = selectedVariants.some((variant) =>
    Object.keys(image.attributes.variants).includes(variant),
  );
  if (!variantExisting) {
    throw new Error('Selected variants not found');
  }

  let variants = Object.entries(image.attributes.variants)
    .filter(([key]) => selectedVariants.includes(key))
    .map(([_, value]) => value);

  // Sort variants by width ascending
  variants = variants.sort((a, b) => a.width - b.width);

  const srcset = variants.map((variant) => `${variant.url} ${variant.width}w`).join(', ');

  const blurSrc = variants[0]?.url; // Smallest for blur
  const src = variants[Math.floor(variants.length / 2)]?.url || variants[0]?.url; // Medium or smallest as fallback

  return {
    srcset,
    src,
    blurSrc,
  };
};

export default useSharetribeImage;